const GET_ADDRESS_DROPDOWN_LIST = 'GET_ADDRESS_DROPDOWN_LIST';
const SET_ADDRESS_DROPDOWN_LIST = 'SET_ADDRESS_DROPDOWN_LIST';

export {
    GET_ADDRESS_DROPDOWN_LIST,
    SET_ADDRESS_DROPDOWN_LIST
};